module.exports = __webpack_public_path__ + "static/media/CircularStd-BookItalic.8b30196c.woff2";